export function moeda(value){
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', currencyDisplay: 'symbol' }).format(value)
}